module.exports = __webpack_public_path__ + "media/images/pharamaday-1442c3ee105535210f95b1ade5043729.jpg";